import { Component,OnInit,ViewChild,ElementRef } from '@angular/core';
import { SessionsService } from '../common/services/sessions.service';
import { FormGroup,FormControl,FormArray } from '@angular/forms';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import {UtilsService} from '../common/services/utils.service';
import * as $ from 'jquery';
declare var set_my_preference_price_range: Function;
declare var show_okshan_alert: Function;
declare var set_multi_select2: Function;

@Component({
  selector: 'app-my-preference',
  templateUrl: './my-preference.component.html',
  styleUrls: ['./my-preference.component.css']
})
export class MyPreferenceComponent implements OnInit {

  stateList=[];
  preferredStateList=[];
  otherStateList=[];
  allStateList=[];
  brandArray=[];
  segmentArray=[
    {"id":1,"name":"Luxury Cars"},
    {"id":2,"name":"Low Segment Cars"},
    {"id":3,"name":"Mid Segment Cars"}
  ];
  allBrand=[];
  myPrefBrand=[];

  myPrefFromGroup;
  prefStates;
  prefSegment;
  prefPriceRange;
  prefBrand;

  selectedPrefStateIds:string="";
  selectedPrefStateIdsArray=[];

  updateBtnLabel="Update";
  preferredStateIds="";

  @ViewChild('rangeFrom') rangeFrom: ElementRef;
  @ViewChild('rangeTo') rangeTo: ElementRef;
  @ViewChild('selectedPreferredState') selectedPreferredState: ElementRef; 

  constructor(
    private sessionsService:SessionsService,
    private httpserviceService:HttpserviceService,
    private utilsService:UtilsService
    ) { }

  ngOnInit(): void {   
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       } 
    window.scrollTo(0, 0);
    this.stateList=this.sessionsService.getSession("state_list");
    this.allStateList=this.sessionsService.getSession("all_state");
    this.brandArray=this.sessionsService.getSession("brand_list");
    this.allBrand=this.sessionsService.getSession("all_brand_list");

    

    this.myPrefFromGroup=new FormGroup(
      {
        prefStates: new FormControl(""),
        prefPriceRangeFrom: new FormControl(""),
        prefPriceRangeTo: new FormControl(""),
        prefBrand: new FormArray([]),
        prefSegment: new FormArray([]),
      }
    ); 
 // setTimeout(() => {
 // set_my_preference_price_range('500000','9900000');  
 // }, 100);  
               
  this.getPreference();    
  }

/** selectState function used to select state */
selectState(id)
{
  if(id!=0 && this.selectedPrefStateIds.indexOf("^"+id+"^")<0)
  {
    this.selectedPrefStateIds=this.selectedPrefStateIds+"^"+id+"^";
    this.myPrefFromGroup.controls['prefStates'].setValue(this.selectedPrefStateIds);   
    this.showSelectedStateList(); 
  }
  else
  {
    show_okshan_alert("This state already selected");
  }
}

/** showSelectedStateList function used to show selected state */
showSelectedStateList()
{
   if(this.utilsService.trimming_fn(this.selectedPrefStateIds)=="")
   {
     this.selectedPrefStateIdsArray=[];
   }
   else
   {
   this.selectedPrefStateIdsArray=this.selectedPrefStateIds.split("^^");   
   for(let i=0;i<this.selectedPrefStateIdsArray.length;i++)
   {
     this.selectedPrefStateIdsArray[i]=this.selectedPrefStateIdsArray[i].replace(/\^/g,"");
   }
   }

   for(let i=0;i<this.stateList.length;i++)
    {
      if(this.stateList[i].preferred==1)
      {
        this.preferredStateList.push(this.stateList[i]);
        this.preferredStateIds=this.preferredStateIds+"^"+this.stateList[i].id+"^";
      }
      else
      {
        this.otherStateList.push(this.stateList[i]);
      }
    }    
    
}

/** removeState function used to remove state */
removeState(id)
{
  if(id!=0)
  {
    this.selectedPrefStateIds=this.selectedPrefStateIds.replace("^"+id+"^","");
    this.myPrefFromGroup.controls['prefStates'].setValue(this.selectedPrefStateIds);   
    this.showSelectedStateList(); 
  }
}

/** proceedSavePreference function used to proceed save preference */
proceedSavePreference(data)
{
  data.prefPriceRangeFrom=this.rangeFrom.nativeElement.value;
  data.prefPriceRangeTo=this.rangeTo.nativeElement.value;
  const selectedBrandIdsArray = this.myPrefFromGroup.value.prefBrand
     .map((v, i) => v ? this.brandArray[i].id : null)
     .filter(v => v !== null); 
  let selectedBrandIds="";
  for(let i=0;i<selectedBrandIdsArray.length;i++)
  {
    selectedBrandIds=selectedBrandIds+"^"+selectedBrandIdsArray[i]+"^";
  }   
  const selectedSegmentIdsArray = this.myPrefFromGroup.value.prefSegment
     .map((v, i) => v ? this.segmentArray[i].id : null)
     .filter(v => v !== null); 
  let selectedSegmentIds="";   
  for(let i=0;i<selectedSegmentIdsArray.length;i++)
  {
    selectedSegmentIds=selectedSegmentIds+"^"+selectedSegmentIdsArray[i]+"^";
  }  
  let selectedStateIds=this.selectedPreferredState.nativeElement.value; 
    selectedStateIds=selectedStateIds.split(',').join('^^'); 
  this.updateBtnLabel="Updating...";
  let result =this.httpserviceService.SavePreferenceRequest(selectedStateIds,data.prefPriceRangeFrom,data.prefPriceRangeTo,
  selectedBrandIds,selectedSegmentIds).
     pipe(retry(0)).
     subscribe((data)=>this.SavePreferenceResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
      this.updateBtnLabel="Update";
       console.log('Something went wrong ', err);       
    })  
  }  

  /** SavePreferenceResponse function used to handle response */
  SavePreferenceResponse(response)
  {    
    console.log('getBrandModelListResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.updateBtnLabel="Update";
       show_okshan_alert("Updated successfully");     
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** getPreference function used to get preference */ 
  getPreference()
  { 
    let result =this.httpserviceService.getPreferenceRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getPreferenceResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getPreferenceResponse function used to handle response */
  getPreferenceResponse(response)
  {    
    console.log('getBrandModelListResponse '+ response.status);
    if(response.status==="success")  
     { 
       let detailArray=response.details
       if(detailArray.length>0)
     {
      for(let i=0;i<detailArray.length;i++)
      {
          this.selectedPrefStateIds=detailArray[i].preferred_state;
          this.myPrefFromGroup.controls['prefStates'].setValue(this.selectedPrefStateIds);
          //=detailArray[i].preferred_car_brand;
          //=detailArray[i].preferred_car_segment;
          this.myPrefFromGroup.controls['prefPriceRangeFrom'].setValue(detailArray[i].price_range_from);
          this.rangeFrom.nativeElement.value=detailArray[i].price_range_from;
          this.myPrefFromGroup.controls['prefPriceRangeTo'].setValue(detailArray[i].price_range_to);
          this.rangeTo.nativeElement.value=detailArray[i].price_range_to;
          set_my_preference_price_range(detailArray[i].price_range_from,detailArray[i].price_range_to);

          this.brandArray.forEach((o, j) => {
            let status =false;
            let brand=detailArray[i].preferred_car_brand;
            if(brand.indexOf("^"+this.brandArray[j].id+"^")>-1)
            {
              status=true;
            }
const control = new FormControl(status); 
(this.myPrefFromGroup.controls.prefBrand as FormArray).push(control);
});

            this.segmentArray.forEach((o, j) => {
              let status =false;
            let segment=detailArray[i].preferred_car_segment;
            if(segment.indexOf("^"+this.segmentArray[j].id+"^")>-1)
            {
              status=true;
            }
const control = new FormControl(status); // if first item set to true, else false
(this.myPrefFromGroup.controls.prefSegment as FormArray).push(control);
}); 

      }
     }
       this.showSelectedStateList();
       setTimeout(() => {
    set_multi_select2();  
    }, 500);
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

}
